import { IGetUserResponse, User, mapUserClaims } from "../../@types/user";


export async function getUserAsync(): Promise<User> {

    try {
        const response = await fetch('auth/user');

        const userResponse: IGetUserResponse = await response.json();

        const userProfile: { [key: string]: any } = {};

        if (userResponse.claims) {
            mapUserClaims(userProfile, userResponse.claims);
        }

        return {
            isAuthenticated: userResponse.isAuthenticated,
            profile: userProfile
        };
    } catch (error) {
        console.log(error);

        throw error;
    }
}

export function login(policyId?: string, companyGuid?: string) {
    const params = new URLSearchParams();

    if (policyId) {
        params.append('policyId', policyId);
    }

    if (companyGuid) {
        params.append('companyGuid', companyGuid);
    }

    const queryString = params.toString();
    const loginUrl = queryString ? `/auth/login?${queryString}` : '/auth/login';

    window.location.href = loginUrl;
}

export function logout() {
    window.location.href = '/auth/logout';
}